import { c as _c } from "react/compiler-runtime";
import { Button, Icon } from "@justhome/react-ui";
interface FormArrayItemProps<T> {
  value: T;
  onEdit: (value: T) => void;
  onDelete: (value: T) => void;
  formatValue: (value: T) => string;
}
const FormArrayItem = t0 => {
  const $ = _c(18);
  const {
    value,
    onEdit,
    onDelete,
    formatValue
  } = t0;
  let t1;
  if ($[0] !== onEdit || $[1] !== value) {
    t1 = () => onEdit(value);
    $[0] = onEdit;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== formatValue || $[4] !== value) {
    t2 = formatValue(value);
    $[3] = formatValue;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="group-hover:hidden">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="hidden group-hover:flex gap-2xs items-center justify-center">Anpassen<Icon type="Edit" size={20} /></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3) {
    t5 = <button type="button" className="bg-primary-50 flex-1 border border-primary-800 rounded-xs text-app-body-1 px-2xs py-xs text-primary-800 hover:text-primary-850 hover:border-primary-850 group focusable" onClick={t1}>{t3}{t4}</button>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onDelete || $[13] !== value) {
    t6 = <Button size="sm" variant="outline_danger" onClick={() => onDelete(value)} aria-label={"L\xF6schen"} iconEnd="Delete" />;
    $[12] = onDelete;
    $[13] = value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="flex gap-2xs justify-between">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default FormArrayItem;